import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import rootReducer from '../redux';
import thunk from 'redux-thunk';

import rootEpics from '../epics';

const epicMiddleware = createEpicMiddleware(rootEpics);
const store = createStore(rootReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), applyMiddleware(thunk,epicMiddleware));

export default ()=>{
    return store;
}


// WEBPACK FOOTER //
// ./src/config/configureStore.js